'use client'

/*
 * Shared renderer for every CMS rich text column (article bodies, client story
 * details). Outputs the stored HTML inside one `.rich-text` wrapper so the
 * server still sends the full text, then runs any embed blocks through
 * mountEmbed. Styling comes from the template's own `.rich-text` rules.
 */
import type { ReactNode } from 'react'

import { useEffect, useRef } from 'react'

import { mountEmbed } from './code-embed'

const MOUNTED = new WeakSet<Element>()

export default function RichText({ html, className }: { html?: string | null, className?: string }): ReactNode {
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        for (const host of Array.from(ref.current?.querySelectorAll<HTMLElement>(':scope > div[data-embed]') ?? [])) {
            if (MOUNTED.has(host) || host.childElementCount > 0) continue
            MOUNTED.add(host)
            mountEmbed(host, host.getAttribute('data-embed') ?? '')
        }
    }, [html])

    return <div ref={ref} className={className ? 'rich-text ' + className : 'rich-text'} dangerouslySetInnerHTML={{ __html: html ?? '' }} />
}
